export var SupportRequestThemeType;
(function (SupportRequestThemeType) {
    SupportRequestThemeType["None"] = "None";
    SupportRequestThemeType["HrRelated"] = "HrRelated";
    SupportRequestThemeType["OrderRelated"] = "OrderRelated";
    SupportRequestThemeType["DevelopersQuestion"] = "DevelopersQuestion";
})(SupportRequestThemeType || (SupportRequestThemeType = {}));
